(() => {
  'use strict';
  const mount = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const abort = new AbortController();
    const listen = (element, event, handler, options = {}) => element.addEventListener(event, handler, { ...options, signal: abort.signal });
    const form = root.querySelector('[data-bulk-form]');
    const quote = root.querySelector('[data-bulk-quote]');
    const button = root.querySelector('[data-bulk-submit]');
    const selection = root.querySelector('[data-bulk-selection]');
    const pricingTerms = selection.textContent;
    const sticky = root.querySelector('[data-bulk-sticky]');
    const gallery = root.querySelector('[data-bulk-gallery]');
    const tabs = [...root.querySelectorAll('[data-bulk-image]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let chosenProduct = '';
    let quoteVisible = false;
    let finalVisible = false;
    const field = name => form.elements.namedItem(name);
    const value = name => String(field(name)?.value || '').trim();
    const clean = name => value(name).replace(/[\r\n]+/g, ' ');
    const number = root.dataset.whatsapp;
    const validNumber = /^[1-9]\d{7,14}$/.test(number);
    if (validNumber) button.disabled = false;
    else {
      button.textContent = 'Please use our store contact details';
      root.querySelectorAll('[data-bulk-chat]').forEach(link => { link.href = '/pages/contact'; });
    }

    // Count the WhatsApp handoff, not a sent message. Never include form data in analytics.
    const track = action => {
      const numericQuantity = Number(value('quantity'));
      const quantityBand = !numericQuantity ? 'not_provided' : numericQuantity <= 10 ? '1-10' : numericQuantity <= 100 ? '11-100' : numericQuantity <= 500 ? '101-500' : '501+';
      const detail = { event: 'pp_bulk_whatsapp_handoff', bulk_category: root.dataset.category, handoff_type: action, quantity_band: quantityBand };
      root.dispatchEvent(new CustomEvent('pp:bulk-whatsapp-handoff', { bubbles: true, detail }));
      const analyticsAllowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
      if (analyticsAllowed && Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
    };
    const refreshSticky = () => {
      const keyboardFocused = /^(INPUT|SELECT|TEXTAREA)$/.test(document.activeElement?.tagName || '');
      sticky.hidden = quoteVisible || finalVisible || keyboardFocused;
    };
    const scrollQuote = () => {
      quote.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      quote.focus({ preventScroll: true });
      refreshSticky();
    };
    root.querySelectorAll('[data-bulk-scroll]').forEach(link => listen(link, 'click', event => { event.preventDefault(); scrollQuote(); }));
    root.querySelectorAll('[data-bulk-chat]').forEach(link => listen(link, 'click', () => track('direct_chat')));
    root.querySelectorAll('[data-bulk-product]').forEach(link => listen(link, 'click', event => {
      event.preventDefault();
      chosenProduct = link.dataset.bulkProduct;
      if (field('range') && link.dataset.bulkRange) field('range').value = link.dataset.bulkRange;
      selection.textContent = 'Product interest: ' + chosenProduct + '. ' + pricingTerms;
      saveDraft();
      scrollQuote();
    }));

    // Keep draft enquiries when returning from WhatsApp, only within this browser tab.
    const storageKey = 'pp-bulk-draft:' + root.dataset.category;
    const saveDraft = () => {
      const fields = ['name', 'quantity', 'city', 'range', 'date', 'company', 'notes'];
      const draft = { expires: Date.now() + 30 * 60 * 1000, chosenProduct, fields: {}, needs: [...form.querySelectorAll('[name=needs]:checked')].map(input => input.value) };
      fields.forEach(name => { if (field(name)) draft.fields[name] = value(name); });
      try { sessionStorage.setItem(storageKey, JSON.stringify(draft)); } catch (_) { /* Storage can be unavailable in private browsing. */ }
    };
    try {
      const draft = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (draft && draft.expires > Date.now()) {
        Object.entries(draft.fields).forEach(([name, text]) => { if (field(name)) field(name).value = text; });
        form.querySelectorAll('[name=needs]').forEach(input => { input.checked = draft.needs?.includes(input.value) || false; });
        chosenProduct = draft.chosenProduct || '';
        if (chosenProduct) selection.textContent = 'Product interest: ' + chosenProduct + '. ' + pricingTerms;
      } else sessionStorage.removeItem(storageKey);
    } catch (_) { /* The enquiry also works without draft storage. */ }
    listen(form, 'input', saveDraft);
    listen(form, 'change', saveDraft);
    if (field('range')) listen(field('range'), 'change', () => {
      chosenProduct = '';
      selection.textContent = pricingTerms;
      saveDraft();
    });
    listen(form, 'submit', event => {
      event.preventDefault();
      field('name').setCustomValidity(clean('name') ? '' : 'Please enter your name.');
      field('city').setCustomValidity(clean('city') ? '' : 'Please enter a delivery city.');
      if (!validNumber || !form.reportValidity()) return;
      const details = [
        'Hello Perfect Plants, I would like a bulk quote.',
        'Category: ' + root.dataset.interest,
        'Name: ' + clean('name'),
        'Quantity: ' + clean('quantity'),
        'Delivery city/cities: ' + clean('city'),
      ];
      if (value('range')) details.push('Range: ' + clean('range'));
      if (chosenProduct) details.push('Product interest: ' + chosenProduct);
      if (value('date')) details.push('Needed by: ' + clean('date'));
      if (value('company')) details.push('Company / occasion: ' + clean('company'));
      const needs = [...form.querySelectorAll('[name=needs]:checked')].map(input => input.value);
      if (needs.length) details.push('Options requested: ' + needs.join(', '));
      if (value('notes')) details.push('Notes: ' + value('notes'));
      details.push('Please confirm product options, final pricing, GST, shipping and delivery feasibility.');
      const source = new URL(location.href);
      details.push('Source: ' + source.origin + source.pathname + (source.searchParams.has('view') ? '?view=' + source.searchParams.get('view') : ''));
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(key => {
        const campaign = source.searchParams.get(key);
        if (campaign) details.push(key + ': ' + campaign.replace(/[\r\n]/g, ' ').slice(0, 120));
      });
      saveDraft();
      track('qualified_quote');
      window.location.assign('https://wa.me/' + number + '?text=' + encodeURIComponent(details.join('\n')));
    });
    ['name', 'city'].forEach(name => listen(field(name), 'input', () => field(name).setCustomValidity('')));

    const date = field('date');
    const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const part = type => today.find(item => item.type === type).value;
    date.min = `${part('year')}-${part('month')}-${part('day')}`;
    const gallerySlides = gallery ? [...gallery.querySelectorAll('.ppg-slide')] : [];
    const selectImage = index => {
      const image = gallerySlides[index]?.querySelector('img');
      const ratio = Number(image?.getAttribute('width')) / Number(image?.getAttribute('height'));
      if (Number.isFinite(ratio) && ratio > 0) gallery.style.setProperty('--ppg-gallery-ratio', ratio);
      tabs.forEach((tab, position) => position === index ? tab.setAttribute('aria-current', 'true') : tab.removeAttribute('aria-current'));
    };
    tabs.forEach(tab => listen(tab, 'click', event => {
      event.preventDefault();
      const index = Number(tab.dataset.bulkImage);
      gallery.scrollTo({ left: gallery.clientWidth * index, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }));
    if (gallery) listen(gallery, 'scroll', () => {
      const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
      selectImage(index);
    }, { passive: true });

    // Preview category links must remain in the same unpublished theme.
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) root.querySelectorAll('[data-bulk-category]').forEach(link => {
      const target = new URL(link.href, location.origin);
      if (target.origin === location.origin) { target.searchParams.set('preview_theme_id', preview); link.href = target.href; }
    });
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === quote) quoteVisible = entry.isIntersecting;
          else finalVisible = entry.isIntersecting;
        });
        refreshSticky();
      });
      observer.observe(quote);
      observer.observe(root.querySelector('.ppg-final'));
    }
    listen(window, 'scroll', refreshSticky, { passive: true });
    listen(window, 'resize', refreshSticky, { passive: true });
    listen(root, 'focusin', refreshSticky);
    listen(root, 'focusout', () => requestAnimationFrame(refreshSticky));
    refreshSticky();
    listen(document, 'shopify:section:unload', event => {
      if (event.target.contains(root)) { observer?.disconnect(); abort.abort(); }
    });
  };
  const init = container => container.querySelectorAll('[data-bulk-gifting]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
